import React, { useCallback } from 'react';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Sort from '@material-ui/icons/Sort';

const Controller = styled.div`
  position: relative;
  width: 100%;
  text-align: right;
  margin-top: 30px;
  &:before{
    position: absolute;
    content: ' ';
    width: 100%;
    height: 1px;
    background-color: black;
    bottom: 0;
    left:0;
  }
`;

const ControllerTitle = styled.div`
  position: absolute;
  bottom: 10px;
`;

const SortIcon = styled(Sort)`
  vertical-align: middle;
  font-size: 20px;
  margin-left: 5px;
`;

const ControllerButton = styled.div`
  background-color: darkgrey;
  padding: 4px 20px;
  display: inline-block;
  position: relative;
  margin: 10px;
  cursor: pointer;
  vertical-align: middle;
  line-height: 30px;
  user-select: none;
  & div{
    display: none;
  }
  &:focus div, &:focus-within div{
    display: block
  }
`;

const ControllerOptionContainer = styled.div`
  position: absolute;
  top: 100%;
  background-color: lightgrey;
  z-index: 99999;
  left: 0;
`;

const ControllerOption = styled.div`
  padding: 10px;
  white-space: nowrap;
`;

export default ({
  title,
}) => {
  const history = useHistory();
  const { t } = useTranslation();

  const sortBySellPriceAsc = useCallback(() => {
    const queryObject = queryString.parse(window.location.search, { arrayFormat: 'index' });
    queryObject.orderBy = 'sellPriceLowest';
    queryObject.reverse = false;
    history.push(`?${queryString.stringify(queryObject)}`);
  }, [history]);

  const sortBySellPriceDesc = useCallback(() => {
    const queryObject = queryString.parse(window.location.search, { arrayFormat: 'index' });
    queryObject.orderBy = 'sellPriceHighest';
    queryObject.reverse = true;
    history.push(`?${queryString.stringify(queryObject)}`);
  }, [history]);

  const sortBySellLastUpdateDesc = useCallback(() => {
    const queryObject = queryString.parse(window.location.search, { arrayFormat: 'index' });
    queryObject.orderBy = 'lastUpdateTime';
    queryObject.reverse = true;
    history.push(`?${queryString.stringify(queryObject)}`);
  }, [history]);

  return (
    <Controller>
      <ControllerButton tabIndex={0}>
        {t('ec.sort')}
        <SortIcon />
        <ControllerOptionContainer>
          <ControllerOption onClick={sortBySellPriceAsc}>
            {t('ec.sort_by_sell_price_asc')}
          </ControllerOption>
          <ControllerOption onClick={sortBySellPriceDesc}>
            {t('ec.sort_by_sell_price_desc')}
          </ControllerOption>
          <ControllerOption onClick={sortBySellLastUpdateDesc}>
            {t('ec.sort_by_last_update_desc')}
          </ControllerOption>
        </ControllerOptionContainer>
      </ControllerButton>
      <ControllerTitle>{ title || t('ec.search_result_products')}</ControllerTitle>
    </Controller>
  );
};
